function fclSlider() {
  const main_slide = document.querySelector('.tp-fcl__slider')
  
  let data_slide = main_slide.getAttribute('data-slide')
  const fcSwiper = document.querySelectorAll('.tp-fcl__slider');
  if (fcSwiper.length > 0) {
    fcSwiper.forEach(function (fclItem) {
      // const dataType = fclItem.dataset.type;
      const spaceBetween = Number(fclItem.dataset.spaceBetween);
      const slidesPerView = Number(fclItem.dataset.desktop);
      const loop = fclItem.dataset.loop === "true";
      const autoplay = fclItem.dataset.autoplay === "true";
      var fcSlider = new Swiper(fclItem, {
        slidesPerView: 1.5,
        slidesPerGroup: 1.5,
        spaceBetween: 15,
        loop: loop,
        autoplay:autoplay,
        freeMode: true,
        preventClicks: true,
        a11y: false,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        breakpoints: {
          410: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1024: {
            slidesPerView: slidesPerView,
            slidesPerGroup: slidesPerView,
            spaceBetween: spaceBetween
          }

        },
        navigation: {
          nextEl: ".swiper-next-fcl",
          prevEl: ".swiper-prev-fcl",
        },

        pagination: {
          clickable: true,
          el: ".swiper-pagination-fcl",
        },
      });
    })
  }
}

fclSlider();

document.addEventListener("shopify:section:load", fclSlider);
document.addEventListener("shopify:section:unload", fclSlider);

